<template>
  <hamv-dialog :dialogProps="dialogProps" :showModal="showModal">
    <span class="el-dialog__title" data-qa="Dialog-DeleteInformationModel-Title" slot="header">{{ $t('informationModelDeleteDialogTitle') }}</span>
    <i18n path="informationModelDeleteConfirmText" tag="span">
      <el-tag place="familyName" type="info">{{ familyName }}</el-tag>
    </i18n>
    <span slot="footer-content">
      <el-alert
        :closable="false"
        :title="alert$.message"
        :type="alert$.type"
        data-qa="Dialog-DeleteInformationModel-Alert"
        show-icon
        v-show="alert$.show"
      >
      </el-alert>
    </span>
    <div slot="actions">
      <el-button
        :class="button.class"
        :data-qa="button.dataQA"
        :disabled="loading || errors.any()"
        :key="index"
        :loading="loading"
        :type="button.type || 'warning'"
        @click.stop="button.click"
        v-for="(button, index) in buttons"
      >
        {{ $t(button.text) }}
      </el-button>
    </div>
  </hamv-dialog>
</template>

<script>
  import main from './InformationModelDelete.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './InformationModelDelete.scss'
</style>



// WEBPACK FOOTER //
// InformationModelDelete.vue?b7a5ef7e